// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { HasOnComplete } from "@insite/client-framework/HandlerCreator";
import { getIsShareEntity } from "@insite/client-framework/ServerSideRendering";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setAddToListModalIsOpen from "@insite/client-framework/Store/Components/AddToListModal/Handlers/SetAddToListModalIsOpen";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import addToWishList, {
    AddToWishListParameter,
} from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";
import translate from "@insite/client-framework/Translate";
import { OrderLineModel, OrderModel, WishListSettingsModel } from "@insite/client-framework/Types/ApiModels";
import CardContainer from "@insite/content-library/Components/CardContainer";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import SmallHeadingAndText, { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import OverflowMenu, { OverflowMenuPresentationProps } from "@insite/mobius/OverflowMenu";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

// Valtech Custom Code --->
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ProductPartNumbers from "@insite/content-library/Components/ProductPartNumbers";
import getColor from "@insite/mobius/utilities/getColor";
import constants from "@store/constants";

import usePrintOption from "@store/Framework/Store/Bunzl/Components/OrderDetailsTotal/Hooks/usePrintOption";
import useCanSeePrices from "@store/Framework/Store/Data/Accounts/Hooks/useCanSeePrices";
import useLocalizeCurrency from "@store/Framework/Common/Hooks/useLocalizeCurrency";
import StoreCheckoutCartLinesHeaderInformations, {
    StoreCheckoutCartLinesHeaderInformationsStyles,
    StoreCheckoutCartLinesHeaderProps,
} from "@store/Library/Components/Foundation/StoreCheckout/StoreCheckoutCartLinesHeaderInformations";
// bunzl custom code - accept qty to display - switch to override
import StoreOrderStatus from "@store/Library/Components/Foundation/StoreOrder/StoreOrderStatus";
import { productLineProps } from "@store/Themes/common/props/productLineProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";

const { userCannotSeePricesMessage } = constants;
// <--- Valtech Custom Code

interface OwnProps {
    order?: OrderModel;
    extendedStyles?: OrderLinesListStyles;
}

const mapStateToProps = (state: ApplicationState) => ({
    wishListSettings: getSettingsCollection(state).wishListSettings,
    enableVat: getSettingsCollection(state).productSettings.enableVat,
    vatPriceDisplay: getSettingsCollection(state).productSettings.vatPriceDisplay,
});

const mapDispatchToProps = {
    setAddToListModalIsOpen,
    addToWishList,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface OrderLineNotesStyles {
    typographyStyles?: TypographyProps;
    gridItemStyles?: GridItemProps;
    // Valtech Custom Code
    wrapper?: InjectableCss;
}

export interface OrderLinesListStyles {
    gridContainer?: GridContainerProps;
    titleGridItem?: GridItemProps;
    titleText?: TypographyProps;
    orderLineCardContainer?: GridContainerProps;
    orderLineCardGridItem?: GridItemProps;
    orderLineCardGridContainer?: GridContainerProps;
    orderLineCardImageGridItem?: GridItemProps;
    productImageLink?: LinkPresentationProps;
    orderLineCardImage?: LazyImageProps;
    orderLineCardInfoGridItem?: GridItemProps;
    orderLineCardInfoGridContainer?: GridContainerProps;
    orderLineCardAddToListGridItem?: GridItemProps;
    orderLineCardActionsWide?: HiddenProps;
    orderLineCardActionsNarrow?: HiddenProps;
    overflowMenu?: OverflowMenuPresentationProps;
    addToListClickable?: ClickablePresentationProps;
    orderLineCardAddToListButton?: ButtonPresentationProps;
    productBrandStyles?: ProductBrandStyles;
    productInfoLink?: LinkPresentationProps;
    productInfoDescription?: TypographyProps;
    productInfoSectionOptionsGridItem?: GridItemProps;
    productInfoSectionOptionsList?: InjectableCss;
    productInfoSectionOptionsListItem?: InjectableCss;
    productInfoPartNumbersGridItem?: GridItemProps;
    productInfoPartNumbersGridContainer?: GridContainerProps;
    productInfoSectionOptionsText?: InjectableCss;
    productInfoGridItem?: GridItemProps;
    productInfoGridContainer?: GridContainerProps;
    productInfoBrandDescriptionGridItem?: GridItemProps;
    productInfoBrandDescriptionGridContainer?: GridContainerProps;
    productInfoBrandGridItem?: GridItemProps;
    productInfoDescriptionGridItem?: GridItemProps;
    productDescriptionStyles?: ProductDescriptionStyles;
    productInfoErpNumberGridItem?: GridItemProps;
    erpNumberHeadingAndText?: SmallHeadingAndTextStyles;
    productInfoManufacturerItemGridItem?: GridItemProps;
    productInfoVmiBinNumberGridItem?: GridItemProps;
    manufacturerHeadingAndText?: SmallHeadingAndTextStyles;
    vmiBinNumberHeadingAndText?: SmallHeadingAndTextStyles;
    productInfoCustomerProductGridItem?: GridItemProps;
    customerProductNumberHeadingAndText?: SmallHeadingAndTextStyles;
    orderLineInfoPromotionGridItem?: GridItemProps;
    orderLineInfoPromotionList?: InjectableCss;
    orderLineInfoPromotionText?: TypographyProps;
    orderLineInfoGridItem?: GridItemProps;
    orderLineInfoGridContainer?: GridContainerProps;
    orderLinePriceGridItem?: GridItemProps;
    priceHeadingAndText?: SmallHeadingAndTextStyles;
    vatLabelText?: TypographyPresentationProps;
    secondaryPriceText?: TypographyPresentationProps;
    secondaryVatLabelText?: TypographyPresentationProps;
    productInfoQtyOrderedGridItem?: GridItemProps;
    productInfoQtyOrderedHeadingAndText?: SmallHeadingAndTextStyles;
    productInfoQtyShippedGridItem?: GridItemProps;
    productInfoQtyShippedHeadingAndText?: SmallHeadingAndTextStyles;
    productInfoSubtotalGridItem?: GridItemProps;
    subtotalWithoutVatHeadingAndText?: SmallHeadingAndTextStyles;
    productInfoSubtotalHeadingAndText?: SmallHeadingAndTextStyles;
    orderLineNotes?: OrderLineNotesStyles;
    productInfoTotalsGridItem?: GridItemProps;
    productInfoTotalsGridContainer?: GridContainerProps;
    // Valtech Custom Code
    productCardGridItem?: GridItemProps;
    productInfosWrapper?: InjectableCss;
    orderLinesListWrapper?: InjectableCss;
    orderLineInfoItem?: InjectableCss;
    mobileOrderLineInfo?: InjectableCss;
    orderLineInfoPrice?: TypographyPresentationProps;
    orderLineExtendedPrice?: TypographyPresentationProps;
    storeCheckoutHeaderStyles?: StoreCheckoutCartLinesHeaderInformationsStyles;
    printableContainer?: InjectableCss;
}

export const orderLinesListStyles: OrderLinesListStyles = {
    gridContainer: {
        gap: 10,
    },
    titleGridItem: {
        width: 12,
    },
    titleText: {
        variant: "h5",
        as: "h2",
        css: css`
            @media print {
                font-size: ${pxToRem(15)};
                padding-top: ${pxToRem(15)};
                margin-bottom: ${pxToRem(5)};
            }
            padding-top: ${pxToRem(30)};
            margin-bottom: 0.5rem;
        `,
    },
    orderLineCardContainer: {
        gap: 10,
    },
    orderLineCardGridContainer: {
        gap: 20,
        css: css`
            border-bottom: ${pxToRem(1)} solid ${getColor("common.border")};
            padding: 1rem 0;
            @media print {
                max-height: ${pxToRem(140)};
            }
        `,
    },
    orderLineCardGridItem: {
        width: 12,
    },
    orderLineCardImageGridItem: {
        width: 2,
        css: css`
            @media print {
                max-height: ${pxToRem(83)};
                max-width: ${pxToRem(83)};
                padding: 0;
            }
        `,
    },
    // bunzl custom code
    orderLineCardImage: {
        css: css`
            > img {
                max-height: ${pxToRem(96)};
            }
        `,
    },
    orderLineCardInfoGridItem: {
        width: [8, 8, 7, 8, 8],
        printWidth: 10,
        css: css`
            @media print {
                &&&& {
                    max-width: 100%;
                }
            }
        `,
    },
    orderLineCardInfoGridContainer: {
        gap: 10,
    },
    orderLineCardAddToListGridItem: {
        width: [2, 2, 3, 2, 2],
        printWidth: 0,
    },
    orderLineCardActionsWide: {
        above: "sm",
    },
    orderLineCardActionsNarrow: {
        below: "md",
    },
    productInfoSectionOptionsGridItem: {
        width: 12,
    },
    productInfoPartNumbersGridItem: {
        width: 12,
    },
    productInfoGridItem: {
        width: [12, 12, 12, 5, 5],
        printWidth: 6,
    },
    productInfoGridContainer: {
        gap: 5,
    },
    productInfoBrandDescriptionGridItem: {
        width: 12,
    },
    productInfoBrandDescriptionGridContainer: {
        gap: 5,
    },
    productInfoBrandGridItem: {
        width: 12,
    },
    productInfoDescriptionGridItem: {
        width: 12,
    },
    productInfoErpNumberGridItem: {
        width: [12, 12, 6, 6, 6],
    },
    productInfoManufacturerItemGridItem: {
        width: [12, 12, 6, 6, 6],
    },
    productInfoVmiBinNumberGridItem: {
        width: [12, 12, 6, 6, 6],
    },
    productInfoCustomerProductGridItem: {
        width: [12, 12, 12, 12, 12],
        printWidth: 12,
    },
    orderLineInfoPromotionGridItem: {
        width: 12,
    },
    orderLineInfoPromotionText: {
        size: 12,
        italic: true,
    },
    orderLineInfoGridItem: {
        ...productLineProps.productControlsGridItem,
        width: productLineProps.productLineControlsWidth,
    },
    orderLineInfoGridContainer: {
        gap: 5,
    },
    orderLinePriceGridItem: {
        width: [12, 12, 12, 4, 4],
        css: css`
            flex-direction: column;
        `,
    },
    vatLabelText: {
        size: 12,
    },
    secondaryVatLabelText: {
        size: 12,
    },
    productInfoQtyOrderedGridItem: {
        width: [6, 6, 4, 3, 3],
        printWidth: 4,
    },
    productInfoQtyShippedGridItem: {
        width: [6, 6, 4, 3, 3],
        printWidth: 4,
    },
    productInfoSubtotalGridItem: {
        width: [12, 12, 4, 6, 6],
        printWidth: 4,
        css: css`
            flex-direction: column;
        `,
    },
    orderLineNotes: {
        gridItemStyles: {
            width: 12,
        },
    },
    productInfoTotalsGridItem: {
        width: [12, 12, 12, 8, 8],
    },
    productInfoTotalsGridContainer: {
        gap: 10,
    },
    productInfoSubtotalHeadingAndText: {
        text: {
            weight: "bold",
        },
    },
    storeCheckoutHeaderStyles: {
        headerCartInfosGridContainer: {
            css: css`
                width: 100%;
            `,
        },
        productInfosGridItem: {
            width: productLineProps.productLineProductWidth,
        },
        productControlsGridItem: {
            width: productLineProps.productLineControlsWidth,
        },
        productControlsItem: {
            css: css`
                width: calc(100% / 3);
            `,
        },
    },
    productCardGridItem: {
        ...productLineProps.productGridItem,
        width: productLineProps.productLineProductWidth,
        css: css`
            @media print {
                display: flex !important;
                width: 100% !important;
            }
        `,
    },
    productInfosWrapper: productLineProps.productInfosWrapper,
    productImageLink: {
        css: productLineProps.productImage?.linkWrappingImage?.css,
    },
    orderLineInfoItem: {
        css: css`
            ${productLineProps.productControlsItem?.css}
            width: calc(100% / 3);
        `,
    },
    productDescriptionStyles: productLineProps.productDescription,
    orderLineInfoPrice: productLineProps.productPrice?.price?.priceText,
    orderLineExtendedPrice: {
        ...productLineProps.extendedUnitNetPriceText,
        css: css`
            font-size: ${({ theme }) => theme.design.typography.size.large};
        `,
    },
    mobileOrderLineInfo: {
        css: css`
            ${productLineProps.mobileProductControls?.css}
            display: flex;
            align-items: center;
        `,
    },
    printableContainer: {
        css: css`
            @media print {
                display: none;
            }
        `,
    },
};

const OrderLineProductInfo = ({ orderLine, styles }: { orderLine: OrderLineModel; styles: OrderLinesListStyles }) => {
    let sectionOptions: JSX.Element[] = [];
    if (orderLine.sectionOptions && orderLine.sectionOptions) {
        sectionOptions = orderLine.sectionOptions.map(option => (
            <li {...styles.productInfoSectionOptionsListItem} key={option.sectionOptionId.toString()}>
                <Typography {...styles.productInfoSectionOptionsText}>
                    {option.sectionName}: {option.optionName}
                </Typography>
            </li>
        ));
    }

    return (
        <GridItem {...styles.productInfoGridItem}>
            <GridContainer {...styles.productInfoGridContainer}>
                <GridItem {...styles.productInfoBrandDescriptionGridItem}>
                    <GridContainer {...styles.productInfoBrandDescriptionGridContainer}>
                        {orderLine.brand && (
                            <GridItem {...styles.productInfoBrandGridItem}>
                                <ProductBrand brand={orderLine.brand} extendedStyles={styles.productBrandStyles} />
                            </GridItem>
                        )}
                        <GridItem {...styles.productInfoDescriptionGridItem}>
                            <ProductDescription product={orderLine} extendedStyles={styles.productDescriptionStyles} />
                        </GridItem>
                    </GridContainer>
                </GridItem>
                {sectionOptions.length > 0 && (
                    <GridItem {...styles.productInfoSectionOptionsGridItem}>
                        <ul {...styles.productInfoSectionOptionsList}>{sectionOptions}</ul>
                    </GridItem>
                )}
                <GridItem {...styles.productInfoPartNumbersGridItem}>
                    <GridContainer {...styles.productInfoPartNumbersGridContainer}>
                        {orderLine.customerProductNumber && (
                            <GridItem {...styles.productInfoCustomerProductGridItem}>
                                <SmallHeadingAndText
                                    {...styles.customerProductNumberHeadingAndText}
                                    heading={translate("My Part #")}
                                    text={orderLine.customerProductNumber}
                                />
                            </GridItem>
                        )}
                        <GridItem {...styles.productInfoErpNumberGridItem}>
                            <SmallHeadingAndText
                                {...styles.erpNumberHeadingAndText}
                                heading={translate("Item #")}
                                text={orderLine.productErpNumber}
                            />
                        </GridItem>
                        {orderLine.manufacturerItem && (
                            <GridItem {...styles.productInfoManufacturerItemGridItem}>
                                <SmallHeadingAndText
                                    {...styles.manufacturerHeadingAndText}
                                    heading={translate("MFG #")}
                                    text={orderLine.manufacturerItem}
                                />
                            </GridItem>
                        )}
                        {orderLine.vmiBinNumber && (
                            <GridItem {...styles.productInfoVmiBinNumberGridItem}>
                                <SmallHeadingAndText
                                    {...styles.vmiBinNumberHeadingAndText}
                                    heading={translate("Bin #")}
                                    text={orderLine.vmiBinNumber}
                                />
                            </GridItem>
                        )}
                    </GridContainer>
                </GridItem>
            </GridContainer>
        </GridItem>
    );
};

const mapStateToOrderLineInfoProps = (state: ApplicationState) => ({
    enableVat: getSettingsCollection(state).productSettings.enableVat,
    vatPriceDisplay: getSettingsCollection(state).productSettings.vatPriceDisplay,
});

const OrderLineInfoProto = ({
    orderLine,
    order,
    enableVat,
    vatPriceDisplay,
    styles,
    // Valtech Custom Code
    isMobile,
}: {
    orderLine: OrderLineModel;
    order: OrderModel;
    enableVat: boolean;
    vatPriceDisplay: string;
    styles: OrderLinesListStyles;
    // Valtech Custom Code
    isMobile?: boolean;
}) => {
    let promotions: JSX.Element[] = [];
    if (order.orderPromotions) {
        promotions = order.orderPromotions
            .filter(promotion => promotion.orderHistoryLineId === orderLine.id)
            .map(promotion => (
                <Typography {...styles.orderLineInfoPromotionText} as="li" key={promotion.id}>
                    {promotion.name}
                </Typography>
            ));
    }

    // Valtech Custom Code --->
    const canUserSeePrices = useCanSeePrices();
    // <--- Valtech Custom Code
    const showPriceTypeSetting = useSettingsCollection().bunzlSettings?.showPriceType;
    const { priceFactor, erpUnitOfMeasure } = orderLine.properties;
    let priceFactorText = "";
    if (showPriceTypeSetting && priceFactor && Number(priceFactor) !== 1) {
        priceFactorText = ` / ${priceFactor} ${erpUnitOfMeasure || "test"}`;
    }

    // Bunzl Custom Code --->
    const localizedCurrency = useLocalizeCurrency();
    const displayVat = enableVat && vatPriceDisplay !== "DisplayWithoutVat";
    let displayPrice = displayVat ? orderLine.unitPriceWithVatDisplay : orderLine.unitPriceDisplay;
    if (priceFactorText) {
        displayPrice += priceFactorText;
    } else {
        displayPrice += orderLine.unitOfMeasure ? ` / ${orderLine.unitOfMeasure}` : "";
    }
    let extendedDisplayPrice: number | string = displayVat
        ? Number(orderLine.netPriceWithVatDisplay)
        : Number(orderLine.extendedUnitNetPrice);

    if (priceFactorText) {
        extendedDisplayPrice = extendedDisplayPrice / Number(priceFactor);
    }

    extendedDisplayPrice = localizedCurrency(extendedDisplayPrice);

    // <--- Bunzl Custom Code

    const printOption = usePrintOption();
    const printableContainer: InjectableCss = printOption ? { ...styles.printableContainer } : {};

    // <--- Valtech Custom Code
    return (
        // Valtech Custom Code
        <>
            <StyledWrapper {...styles.orderLineInfoItem}>
                {isMobile ? (
                    <StyledWrapper {...printableContainer}>
                        <SmallHeadingAndText
                            {...styles.priceHeadingAndText}
                            heading={translate("Price")}
                            text={
                                canUserSeePrices /* Valtech Custom Code */ ? displayPrice : userCannotSeePricesMessage()
                            }
                        />
                    </StyledWrapper>
                ) : (
                    <StyledWrapper {...styles.printableContainer}>
                        <Typography {...styles.orderLineInfoPrice}>
                            {canUserSeePrices /* Valtech Custom Code */ ? displayPrice : userCannotSeePricesMessage()}
                        </Typography>
                        {enableVat && (
                            <>
                                <Typography as="p" {...styles.vatLabelText}>
                                    {vatPriceDisplay === "DisplayWithVat" ||
                                    vatPriceDisplay === "DisplayWithAndWithoutVat"
                                        ? `${translate("Inc. VAT")} (${orderLine.taxRate}%)`
                                        : translate("Ex. VAT")}
                                </Typography>
                                {vatPriceDisplay === "DisplayWithAndWithoutVat" && (
                                    <>
                                        <Typography {...styles.secondaryPriceText} as="p">
                                            {orderLine.unitPriceDisplay +
                                                (orderLine.unitOfMeasure ? ` / ${orderLine.unitOfMeasure}` : "")}
                                        </Typography>
                                        <Typography as="p" {...styles.secondaryVatLabelText}>
                                            {translate("Ex. VAT")}
                                        </Typography>
                                    </>
                                )}
                            </>
                        )}
                    </StyledWrapper>
                )}
            </StyledWrapper>
            <StyledWrapper {...styles.orderLineInfoItem}>
                {isMobile ? (
                    <SmallHeadingAndText
                        {...styles.productInfoQtyOrderedHeadingAndText}
                        heading={translate("QTY")}
                        text={`${orderLine.qtyOrdered}`}
                    />
                ) : (
                    <StyledWrapper {...styles.printableContainer}>
                        <Typography>{orderLine.qtyOrdered}</Typography>
                    </StyledWrapper>
                )}
            </StyledWrapper>
            <StyledWrapper {...styles.orderLineInfoItem}>
                {isMobile ? (
                    <StyledWrapper {...printableContainer}>
                        <SmallHeadingAndText
                            heading={
                                !enableVat
                                    ? translate("Total")
                                    : vatPriceDisplay !== "DisplayWithoutVat"
                                    ? `${translate("Total")} (${translate("Inc. VAT")})`
                                    : `${translate("Total")} (${translate("Ex. VAT")})`
                            }
                            text={canUserSeePrices /* Valtech Custom Code */ ? extendedDisplayPrice : translate("--")}
                            extendedStyles={styles.productInfoSubtotalHeadingAndText}
                        />
                    </StyledWrapper>
                ) : (
                    <StyledWrapper {...styles.printableContainer}>
                        {/* bunzl custom code  make sure extended price styles are the same as the price styles */}
                        <Typography {...styles.orderLineInfoPrice}>
                            {canUserSeePrices /* Valtech Custom Code */ ? extendedDisplayPrice : translate("--")}
                        </Typography>
                    </StyledWrapper>
                )}
            </StyledWrapper>
        </>
        // Valtech Custom Code
    );
};

const OrderLineInfo = connect(mapStateToOrderLineInfoProps)(OrderLineInfoProto);

const OrderLineNotes = ({
    orderLine,
    extendedStyles,
}: {
    orderLine: OrderLineModel;
    extendedStyles?: OrderLineNotesStyles;
}) => {
    return orderLine.notes ? (
        <GridItem {...extendedStyles?.gridItemStyles}>
            <Typography {...extendedStyles?.typographyStyles}>{orderLine.notes}</Typography>
        </GridItem>
    ) : null;
};

const OrderLineCard = (props: {
    orderLine: OrderLineModel;
    order: OrderModel;
    wishListSettings?: WishListSettingsModel;
    styles: OrderLinesListStyles;
    setAddToListModalIsOpen: (parameter: {
        productInfos?: Omit<ProductInfo, "productDetailPath">[];
        modalIsOpen: boolean;
    }) => void;
    addToWishList: (parameter: AddToWishListParameter & HasOnComplete) => void;
}) => {
    const { orderLine, order, wishListSettings, styles, setAddToListModalIsOpen, addToWishList } = props;
    const toasterContext = React.useContext(ToasterContext);
    const addToListClickHandler = () => {
        if (!wishListSettings) {
            return;
        }

        const productInfo = {
            productId: orderLine.productId,
            qtyOrdered: orderLine.qtyOrdered,
            unitOfMeasure: orderLine.unitOfMeasure,
        };
        if (!wishListSettings.allowMultipleWishLists) {
            addToWishList({
                productInfos: [productInfo],
                onSuccess: () => {
                    toasterContext.addToast({ body: siteMessage("Lists_ProductAdded"), messageType: "success" });
                },
            });
            return;
        }

        setAddToListModalIsOpen({ modalIsOpen: true, productInfos: [productInfo] });
    };

    const isShareEntity = getIsShareEntity();
    // Valtech Custom Code
    const productImagePath = orderLine.mediumImagePath;
    // Valtech Custom Code

    // bunzl custom code - calculate backordered qty
    const backorderedQty =
        orderLine.properties?.showBackorderedQty === "true" ? orderLine.qtyOrdered - orderLine.qtyShipped : undefined;

    return (
        <GridContainer
            {...styles.orderLineCardGridContainer}
            data-test-selector={`orderLineCard${orderLine.productId}`}
        >
            {/* Valtech Custom Code */}
            <GridItem {...styles.productCardGridItem}>
                {orderLine.productUri && orderLine.isActiveProduct && (
                    <Link {...styles.productImageLink} href={orderLine.productUri}>
                        <LazyImage
                            {...styles.orderLineCardImage}
                            src={productImagePath /* Valtech Custom Code */}
                            isShareEntity={isShareEntity}
                        />
                    </Link>
                )}
                <StyledWrapper {...styles.productInfosWrapper}>
                    {orderLine.brand && (
                        <ProductBrand brand={orderLine.brand} extendedStyles={styles.productBrandStyles} />
                    )}
                    <ProductDescription product={orderLine} extendedStyles={styles.productDescriptionStyles} />
                    <ProductPartNumbers
                        productNumber={orderLine.productErpNumber}
                        customerProductNumber={orderLine.customerName}
                        manufacturerItem={orderLine.manufacturerItem}
                    />
                    {/* Bunzl Custom Code - start */}
                    <StoreOrderStatus status={orderLine.status} qty={backorderedQty} />
                    {/* Bunzl Custom Code - end */}
                    <StyledWrapper {...styles.mobileOrderLineInfo}>
                        <OrderLineInfo orderLine={orderLine} order={order} styles={styles} isMobile />
                    </StyledWrapper>
                </StyledWrapper>
            </GridItem>
            <GridItem {...styles.orderLineInfoGridItem}>
                <OrderLineInfo orderLine={orderLine} order={order} styles={styles} />
            </GridItem>
            {/* Valtech Custom Code */}
        </GridContainer>
    );
};

const OrderLinesList: FC<Props> = ({
    order,
    wishListSettings,
    setAddToListModalIsOpen,
    addToWishList,
    extendedStyles,
}) => {
    const [styles] = React.useState(() => mergeToNew(orderLinesListStyles, extendedStyles));

    if (!order || !order.orderLines) {
        return null;
    }

    // Valtech Custom Code
    const headerProps: StoreCheckoutCartLinesHeaderProps = {
        controlLabels: [{ label: translate("Price") }, { label: translate("Quantity") }, { label: translate("Total") }],
        extendedStyles: styles.storeCheckoutHeaderStyles,
    };
    // Valtech Custom Code

    return (
        <StyledWrapper {...styles.orderLinesListWrapper}>
            <StoreCheckoutCartLinesHeaderInformations {...headerProps} /* Valtech Custom Code */ />
            {order.orderLines.map(orderLine => (
                // Valtech Custom Code
                <OrderLineCard
                    key={orderLine.id}
                    orderLine={orderLine}
                    order={order}
                    wishListSettings={wishListSettings}
                    styles={styles}
                    setAddToListModalIsOpen={setAddToListModalIsOpen}
                    addToWishList={addToWishList}
                />
                // Valtech Custom Code
            ))}
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderLinesList);
